var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGGradient = function SvgGGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 39,
    fill: "none",
    viewBox: "0 0 65 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G_Gradient_svg__a)",
    fillRule: "evenodd",
    d: "M37.803 17.838c1.155 0 2.093.937 2.093 2.09v12.266c0 4.23-3.436 7.663-7.67 7.663H7.67c-4.234 0-7.67-3.432-7.67-7.663V7.664C0 3.431 3.436 0 7.67 0H65v4.18H7.671a3.483 3.483 0 0 0-3.486 3.483v24.531a3.483 3.483 0 0 0 3.486 3.482h24.554a3.483 3.483 0 0 0 3.486-3.482V19.929c0-1.154.938-2.09 2.092-2.09Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "G_Gradient_svg__a",
    x1: 0,
    x2: 55.333,
    y1: 15.262,
    y2: 15.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EA5188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#F5845A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FFC979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC978",
    stopOpacity: 0
  })))));
};
export default SvgGGradient;